import FocusStyle from './components/focus-style'

// Add focus behaviour
const focusStyle = new FocusStyle()
focusStyle.init()

// Add article list variant 1
if (document.querySelector('.article-list--variant-1')) {
  import('./components/article-list-variant-1')
    .then(({ ArticleListVariant1 }) => {
      const articleListVariant1 = new ArticleListVariant1()
      articleListVariant1.init()
    })
}

// Add article list variant 2
if (document.querySelector('.article-list--variant-2')) {
  import('./components/article-list-variant-2')
    .then(({ ArticleListVariant2 }) => {
      const articleListVariant2 = new ArticleListVariant2()
      articleListVariant2.init()
    })
}

// Add button-burger functions
if (document.querySelector('.button--burger')) {
  import('./components/button-burger')
    .then(({ ButtonBurger }) => {
      const buttonBurger = new ButtonBurger()
      buttonBurger.init()
    })
}

// Add button-search functions
if (document.querySelector('.button--search')) {
  import('./components/button-search')
    .then(({ ButtonSearch }) => {
      const buttonSearch = new ButtonSearch()
      buttonSearch.init()
    })
}

// Add disturbances variant 1 functions
if (document.querySelector('.disturbances--variant-1')) {
  import('./components/disturbances-variant-1')
    .then(({ DisturbancesVariant1 }) => {
      const disturbancesVariant1 = new DisturbancesVariant1()
      disturbancesVariant1.init()
    })
}

// Add main-navigation functions
if (document.querySelector('.main-navigation')) {
  import('./components/main-navigation')
    .then(({ MainNavigation }) => {
      const mainNavigation = new MainNavigation()
      mainNavigation.init()
    })
}

// Add gallery variant 1 functions
if (document.querySelector('.gallery--variant-1')) {
  import('./components/gallery-variant-1')
    .then(({ GalleryVariant1 }) => {
      const galleryVariant1 = new GalleryVariant1()
      galleryVariant1.init()
    })
}

// Add gallery variant 2 functions
if (document.querySelector('.gallery--variant-2')) {
  import('./components/gallery-variant-2')
    .then(({ GalleryVariant2 }) => {
      const galleryVariant2 = new GalleryVariant2()
      galleryVariant2.init()
    })
}

// Add gallery variant 3 functions
if (document.querySelector('.gallery--variant-3')) {
  import('./components/gallery-variant-3')
    .then(({ GalleryVariant3 }) => {
      const galleryVariant3 = new GalleryVariant3()
      galleryVariant3.init()
    })
}

// Add gallery variant 4 functions
if (document.querySelector('.gallery--variant-4')) {
  import('./components/gallery-variant-4')
    .then(({ GalleryVariant4 }) => {
      const galleryVariant4 = new GalleryVariant4()
      galleryVariant4.init()
    })
}

// Add page-header functions
if (document.querySelector('.page-header')) {
  import('./components/page-header')
    .then(({ PageHeader }) => {
      const pageHeader = new PageHeader()
      pageHeader.init()
    })
}

// Add page navigation variant 1
if (document.querySelector('.page-navigation--variant-1')) {
  import('./components/page-navigation-variant-1')
    .then(({ PageNavigationVariant1 }) => {
      const pageNavigationVariant1 = new PageNavigationVariant1()
      pageNavigationVariant1.init()
    })
}

// Add parallax effects
if (document.querySelector('.parallax')) {
  import('./components/parallax')
    .then(({ Parallax }) => {
      const parallax = new Parallax()
      parallax.init()
    })
}

// Add press list
if (document.querySelector('.press-list')) {
  import('./components/press-list')
    .then(({ PressList }) => {
      const pressList = new PressList()
      pressList.init()
    })
}

// Add news list
if (document.querySelector('.news-list')) {
  import('./components/news-list')
    .then(({ NewsList }) => {
      const newsList = new NewsList()
      newsList.init()
    })
}

// Add modal variant 1
if (document.querySelector('.modal--variant-1')) {
  import('./components/modal-variant-1')
    .then(({ ModalVariant1 }) => {
      const modalVariant1 = new ModalVariant1()
      modalVariant1.init()
    })
}

// Add modal variant 2
if (document.querySelector('.modal--variant-2')) {
  import('./components/modal-variant-2')
    .then(({ ModalVariant2 }) => {
      const modalVariant2 = new ModalVariant2()
      modalVariant2.init()
    })
}

// Add modal variant 3
if (document.querySelector('.modal--variant-3')) {
  import('./components/modal-variant-3')
    .then(({ ModalVariant3 }) => {
      const modalVariant3 = new ModalVariant3()
      modalVariant3.init()
    })
}

// Add gravityform functions
if (document.querySelector('.gform_wrapper')) {
  import('./components/gravityform')
    .then(({ Gravityform }) => {
      const gravityform = new Gravityform()
      gravityform.init()
    })
}

// Add map variant 1
if (document.querySelector('.map--variant-1')) {
  import('./components/map-variant-1')
    .then(({ MapVariant1 }) => {
      const mapVariant1 = new MapVariant1()
      mapVariant1.init()
    })
}

// Add map variant 2
if (document.querySelector('.map--variant-2')) {
  import('./components/map-variant-2')
    .then(({ MapVariant2 }) => {
      const mapVariant2 = new MapVariant2()
      mapVariant2.init()
    })
}

// Add real estate detail variant 1
if (document.querySelector('.real-estate-detail--variant-1')) {
  import('./components/real-estate-detail-variant-1')
    .then(({ RealEstateDetailVariant1 }) => {
      const realEstateDetailVariant1 = new RealEstateDetailVariant1()
      realEstateDetailVariant1.init()
    })
}

// Add dynamic select
if (document.querySelector('select, .dynamic-select')) {
  import('./components/dynamic-select')
    .then(({ DynamicSelect }) => {
      const dynamicSelect = new DynamicSelect()
      dynamicSelect.init()
    })
}

// Add service center variant 1
if (document.querySelector('.service-center--variant-1')) {
  import('./components/service-center-variant-1')
    .then(({ ServiceCenterVariant1 }) => {
      const serviceCenterVariant1 = new ServiceCenterVariant1()
      serviceCenterVariant1.init()
    })
}

// Add tabs variant 1
if (document.querySelector('.tabs--variant-1')) {
  import('./components/tabs-variant-1')
    .then(({ TabsVariant1 }) => {
      const tabsVariant1 = new TabsVariant1()
      tabsVariant1.init()
    })
}

// Add video box variant 1
if (document.querySelector('.video-box--variant-1')) {
  import('./components/video-box-variant-1')
    .then(({ VideoBoxVariant1 }) => {
      const videoVariant1 = new VideoBoxVariant1()
      videoVariant1.init()
    })
}

// Add video box variant 2
if (document.querySelector('.video-box--variant-2')) {
  import('./components/video-box-variant-2')
    .then(({ VideoBoxVariant2 }) => {
      const videoVariant2 = new VideoBoxVariant2()
      videoVariant2.init()
    })
}

// Add video box variant 3
if (document.querySelector('.video-box--variant-3')) {
  import('./components/video-box-variant-3')
    .then(({ VideoBoxVariant3 }) => {
      const videoVariant3 = new VideoBoxVariant3()
      videoVariant3.init()
    })
}

// Add read more
if (document.querySelector('.read-more')) {
  import('./components/read-more')
    .then(({ ReadMore }) => {
      const readMore = new ReadMore()
      readMore.init()
    })
}
